<template>
  <span>
    <b-link @click="$bvModal.show(modalId)">Reactivate</b-link>

    <b-modal ref="modal" :id="modalId" title="Reactivate Device" centered>
      <b-container fluid>
        <b-row>
          <b-col sm="12">
            Really reactivate device <strong>{{ deviceUid }}</strong>?
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="12">
            <div class="error">{{ err }}</div>
          </b-col>
        </b-row>
      </b-container>
      <template v-slot:modal-footer="{ cancel }">
        <b-button variant="outline-secondary" @click="cancel()">
          Cancel
        </b-button>
        <b-button variant="warning" @click="reactivateDevice">
          <b-spinner small v-show="processing"></b-spinner>
          <span v-show="!processing">Reactivate Device</span>
        </b-button>
      </template>
    </b-modal>
  </span>
</template>


<script>

import {API} from "aws-amplify";
import {store} from "@/main";


export default {
  name: "ReactivateDeviceButton",
  props: {
    identity: String,
    deviceUid: String,
    onSuccess: Function,
  },
  data: function() {
    return {
      processing: false,
      err: ' ',
    }
  },
  computed: {
    modalId: function() {
      return 'modal-reactivate-device-' + this.deviceUid
    },
  },
  methods: {
    reactivateDevice() {
      this.processing = true;
      this.err = ' ';

      API.post(store.state.api, "/put", {
        body: JSON.stringify({
          q: 57,
          identity: this.identity,
          deviceUid: this.deviceUid,
        }),
      })
          .then(() => {
            this.processing = false;
            this.$refs['modal'].hide()
            this.onSuccess()
          })
          .catch(() => {
            this.processing = false;
            this.err = 'Error reactivating device';
          });
    }
  },
}
</script>



<style scoped>
.error {
  display: block;
  color: red;
  margin-top: 10px;
  text-align: center;
}
a {
  font-size: 80%;
  padding: 10px;
}
</style>